(() => {
  function whenThemeReady(cb) {
    if (window.themeCore && window.themeCore.loaded) {
      cb();
      return;
    }
    document.addEventListener("theme:all:loaded", cb, { once: true });
  }

  function initOne(root) {
    if (!root) return;

    if (root.dataset.sliderInitialized === "true") return;

    const track = root.querySelector(".js-cart-upsell-slider-track");
    const nextBtn = root.querySelector(".js-cart-upsell-slider-next");
    const prevBtn = root.querySelector(".js-cart-upsell-slider-prev");
    if (!track || !nextBtn || !prevBtn) return;

    const getStep = () => {
      const slide = track.querySelector(".cart-upsell-slider__slide");
      if (!slide) return 260;
      const slideRect = slide.getBoundingClientRect();
      const trackStyles = window.getComputedStyle(track);
      const gap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap || "16") || 16;
      return Math.max(100, slideRect.width + gap);
    };

    const scrollByStep = (dir) => {
      track.scrollBy({ left: dir * getStep(), behavior: "smooth" });
    };

    const updateNavButtons = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const atStart = track.scrollLeft <= 1;
      const atEnd = track.scrollLeft >= maxScroll - 1;
      const noOverflow = maxScroll <= 1;

      prevBtn.disabled = atStart || noOverflow;
      nextBtn.disabled = atEnd || noOverflow;
    };

    const onNext = (e) => {
      e.preventDefault();
      if (nextBtn.disabled) return;
      scrollByStep(1);
    };
    const onPrev = (e) => {
      e.preventDefault();
      if (prevBtn.disabled) return;
      scrollByStep(-1);
    };

    nextBtn.addEventListener("click", onNext);
    prevBtn.addEventListener("click", onPrev);
    track.addEventListener("scroll", updateNavButtons, { passive: true });
    window.addEventListener("resize", updateNavButtons);
    updateNavButtons();

    root.dataset.sliderInitialized = "true";
  }

  function initAll(scope = document) {
    const roots = scope.querySelectorAll(".js-cart-upsell-slider");
    roots.forEach((root) => initOne(root));
  }

  function scheduleInit() {
    // Cart updates replace DOM inside sections; run after it finishes.
    setTimeout(() => initAll(document), 0);
    setTimeout(() => initAll(document), 100);
    setTimeout(() => initAll(document), 300);
  }

  const boot = () => whenThemeReady(() => initAll(document));
  boot();

  // Observe DOM changes (AJAX cart re-render injects markup; scripts won't rerun)
  function setupObserver() {
    if (window.__cartUpsellSliderObserver) return;
    const target = document.body;
    if (!target || typeof MutationObserver !== "function") return;

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type !== "childList") continue;
        if (!m.addedNodes || m.addedNodes.length === 0) continue;
        // If slider was injected, (re)init it
        if (
          Array.from(m.addedNodes).some(
            (n) =>
              n &&
              n.nodeType === 1 &&
              (n.matches?.(".js-cart-upsell-slider") || n.querySelector?.(".js-cart-upsell-slider"))
          )
        ) {
          scheduleInit();
          break;
        }
      }
    });

    observer.observe(target, { childList: true, subtree: true });
    window.__cartUpsellSliderObserver = observer;
  }

  // Re-init after AJAX cart refreshes
  whenThemeReady(() => {
    setupObserver();
    if (window.themeCore && window.themeCore.EventBus && typeof window.themeCore.EventBus.listen === "function") {
      window.themeCore.EventBus.listen("cart:updated", scheduleInit);
      window.themeCore.EventBus.listen("cart:refresh", scheduleInit);
      window.themeCore.EventBus.listen("cart:drawer:open", scheduleInit);
      window.themeCore.EventBus.listen("cart:drawer:refresh-and-open", scheduleInit);
    }
  });
})();

